import styled from 'styled-components';

const Input = styled.input`
  height: 25px;
  border: 1px solid lightgrey;
  border-radius: 4px;
  box-shadow: none;
  display: block;
  width: 50%;
  margin: 5px auto;
`;

export default Input;



// WEBPACK FOOTER //
// ./src/components/styledComponents/Input.js